import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

/**
 * Dedicated route for direct navigation to /admin/logout (e.g. bookmarked links,
 * browser history). Performs the same logout as the sidebar "Logout" button,
 * then redirects to the admin login page — avoids a "no routes matched" warning
 * when this URL is visited directly instead of only via the Logout button.
 */
export default function AdminLogout() {
  const navigate = useNavigate();
  const { logoutAdmin } = useAuth();

  useEffect(() => {
    logoutAdmin();
    navigate("/admin/login", { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid="admin-logout-page" className="min-h-screen flex items-center justify-center bg-[hsl(var(--secondary))]">
      <div className="flex items-center gap-2 text-muted-foreground text-sm">
        <Loader2 className="h-4 w-4 animate-spin" /> Signing out...
      </div>
    </div>
  );
}
